import React, { useCallback, useState } from 'react';
import { Popover } from '@philips-internal/oswald-ui-components';
import { seizeAndForwardChildrenEvents } from '@philips-internal/oswald-ui-utils';
import { ContextMenuItem } from './context-menu-item.js';
import './context-menu.css';
function ContextMenu(props) {
    const [open, setOpen] = useState(false);
    const onContextMenu = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(props.actions.length > 0);
    }, [props.actions.length]);
    const onClose = useCallback(() => {
        setOpen(false);
    }, []);
    const seizedChildren = seizeAndForwardChildrenEvents(props.children, [
        ['onContextMenu', onContextMenu],
    ])[0];
    return (React.createElement(Popover, { alignment: props.alignment, onClose: onClose, open: open, padding: 0, placement: props.placement, showArrow: false, targetRef: props.targetRef },
        seizedChildren,
        React.createElement(Popover.Content, null,
            React.createElement("div", { className: "c-oswald-context-menu" }, props.actions.map(action => (React.createElement(ContextMenuItem, { action: action, key: action.id, onClick: () => setOpen(false) })))))));
}
export { ContextMenu, };
//# sourceMappingURL=context-menu.js.map